import { useShare } from 'app/features/sharing/hooks'
import { copyToClipboard } from 'app/lib/copy-to-clipboard'
import { useAuth } from 'app/provider/auth'
import { useState } from 'react'
import { ReferFriendBlock } from './refer-friend.block'
import { ReferFriendComponent } from './refer-friend.component'

export const ReferFriendContainer = (block: ReferFriendBlock) => {
  const { user } = useAuth();
  const { onShare } = useShare({ href: user?.referralUrl || "" })
  const [isCopied, setIsCopied] = useState(false)

  // You can't refer a friend if you're not logged in
  if (!user) {
    return null
  }

  // You can't refer a friend if you don't have a referral url
  if (!user?.referralUrl) {
    return null
  }

  return (
    <ReferFriendComponent
      {...block}
      copied={isCopied}
      referralUrl={user.referralUrl}
      onCopyLink={() => {
        copyToClipboard(user.referralUrl!)

        setIsCopied(true)
        setTimeout(() => setIsCopied(false), 4000)
      }}
      onShare={onShare}
    />
  )
}
